angular.module('aprima-provider-api').factory('LockManager', ['LockRepository', '$log', '_', '$rootScope', '$interval', '$q', 'CurrentUser',
    function (LockRepository, $log, _, $rootScope, $interval, $q, CurrentUser) {
        'use strict';

        var locks = [],
            refreshInterval;

        function findLock(lockType, objectId) {
            return _.find(locks, {LockType: lockType, ObjectId: objectId});
        }

        function lock(lockType, objectId) {
            return LockRepository.lock(lockType, objectId)
                .then(function (l) {
                    locks.push(l.plain());

                    return l;
                });
        }

        function unlock(lockType, objectId) {
            var currentLock = findLock(lockType, objectId);

            if (!currentLock) {
                return $q.reject(new Error('Lock was not found in local cache'));
            }

            return LockRepository.unlock(currentLock.LockType, currentLock.ObjectId, currentLock.InstanceId)
                .then(function () {
                    _.remove(locks, function (l) {
                        return l.LockType.toLowerCase() === currentLock.LockType.toLowerCase() &&
                            l.ObjectId.toLowerCase() === currentLock.ObjectId.toLowerCase() &&
                            l.InstanceId.toLowerCase() === currentLock.InstanceId.toLowerCase();
                    });
                }, function (response) {
                    $log.error('Error unlocking lock id= ' + objectId);
                    $log.error(response);
                });
        }

        function isLocked(lockType, objectId, instanceId) {
            return LockRepository.isLocked(lockType, objectId, instanceId);
        }

        function refreshLocks() {
            if (!locks || !locks.length || !CurrentUser.isAuthenticated) {
                return;
            }

            _.each(locks, refreshLock);
        }

        function refreshLock(lock) {
            LockRepository.lock(lock.LockType, lock.ObjectId, lock.InstanceId)
                .then(function (lockResponse) {
                    lockResponse = lockResponse.plain();

                    _.remove(locks, lock);
                    locks.push(lockResponse);

                    $rootScope.$broadcast('locks.updated', {oldLock: lock, newLock: lockResponse, isLocked: true});
                }, function (response) {
                    $log.error('Error refreshing lock: ');
                    $log.error(response);

                    _.remove(locks, lock);
                    $rootScope.$broadcast('locks.updated', {oldLock: lock, newLock: response.data, isLocked: false});
                });
        }

        function startRefreshingLocks() {
            refreshInterval = $interval(refreshLocks, 30000);
        }

        function stopRefreshingLocks() {
            $interval.cancel(refreshInterval);
        }
        
        return {
            lock: lock,
            unlock: unlock,
            isLocked: isLocked,
            getLocks: function() {
                return _.cloneDeep(locks);
            },
            refreshLocks: refreshLocks,
            startRefreshingLocks: startRefreshingLocks,
            stopRefreshingLocks: stopRefreshingLocks
        };
    }]);